<template>
	<div :class="appTheme" class="pt-0.5">
		<!-- App header -->
		<AppHeader :theme="appTheme" @themeChanged="updateTheme" />

		<!-- Render active component contents with vue transition -->
		<router-view v-slot="{ Component }">
			<transition name="fade" mode="out-in">
				<component :is="Component" :theme="appTheme" />
			</transition>
		</router-view>

		<!-- Scroll to top -->
		<back-to-top
			visibleoffset="500"
			right="30px"
			bottom="20px"
			class="shadow-lg"
		>
			<FeatherIcon name="chevron-up" iconClass="w-5 h-5" />
		</back-to-top>

		<!-- App footer -->
		<AppFooter />
	</div>
</template>

<script>
import AppHeader from './components/shared/AppHeader';
import AppFooter from './components/shared/AppFooter';
import FeatherIcon from './components/FeatherIcon.vue';

export default {
	components: {
		AppHeader,
		AppFooter,
		FeatherIcon,
	},
	data: () => {
		return {
			appTheme: localStorage.getItem('theme') || 'light',
		};
	},
	methods: {
		updateTheme(newTheme) {
			this.appTheme = newTheme;
			const body = document.querySelector('body');
			if (body && body.classList.contains('app-theme')) {
				body.classList.remove('bg-primary-dark', 'bg-secondary-light');
				body.classList.add(newTheme === 'dark' ? 'bg-primary-dark' : 'bg-secondary-light');
			}
		},
	},
};
</script>

<style>
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
}

.vue-back-to-top {
	@apply p-2 bg-indigo-500 hover:bg-indigo-600 text-white transition
        duration-500
        ease-in-out
        transform
        hover:-translate-y-1 hover:scale-110;
	border-radius: 50%;
	font-size: 22px;
	line-height: 22px;
}

.fade-enter-active {
	animation: coming 0.4s;
	animation-delay: 0.2s;
	opacity: 0;
}

.fade-leave-active {
	animation: going 0.4s;
}

@keyframes going {
	from {
		transform: translateX(0);
	}

	to {
		transform: translateX(-10px);
		opacity: 0;
	}
}

@keyframes coming {
	from {
		transform: translateX(-10px);
		opacity: 0;
	}

	to {
		transform: translateX(0px);
		opacity: 1;
	}
}
</style>
